import {RefreshCw} from 'lucide-react';
import {useTranslation} from 'react-i18next';
import {Button, cn} from '@chekinapp/ui';

type SplashSlowActionsProps = {
  onRetry: () => void;
  className?: string;
};

function SplashSlowActions({onRetry, className}: Readonly<SplashSlowActionsProps>) {
  const {t} = useTranslation();

  return (
    <div
      className={cn(
        'mt-6 flex w-full max-w-[300px] flex-col items-center gap-2.5',
        className,
      )}
    >
      <Button variant="outline" className="w-full" onClick={onRetry}>
        <RefreshCw size={16} aria-hidden="true" />
        {t('try_again')}
      </Button>
      <p className="max-w-[280px] text-center text-xs font-medium leading-[17px] text-[color:var(--sp-ink-faint)]">
        {t('splash_nothing_lost')}
      </p>
    </div>
  );
}

export {SplashSlowActions};
